import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["class", "className"];
import clsx from "clsx";

var falsyToString = function falsyToString(value) {
  return typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
};

export var cx = clsx;
export var cva = function cva(base, config) {
  return function (props) {
    var ref;
    if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    var variants = config.variants,
        defaultVariants = config.defaultVariants;
    var getVariantClassNames = Object.keys(variants).map(function (variant) {
      var variantProp = props === null || props === void 0 ? void 0 : props[variant];
      var defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
      if (variantProp === null) return null;
      var variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
      return variants[variant][variantKey];
    });
    var propsWithoutUndefined = props && Object.entries(props).reduce(function (acc, param) {
      var _param = _slicedToArray(param, 2),
          key = _param[0],
          value = _param[1];

      if (value === undefined) {
        return acc;
      }

      acc[key] = value;
      return acc;
    }, {});
    var getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce(function (acc, param1) {
      var cvClass = param1.class,
          cvClassName = param1.className,
          compoundVariantOptions = _objectWithoutProperties(param1, _excluded);

      return Object.entries(compoundVariantOptions).every(function (param) {
        var _param2 = _slicedToArray(param, 2),
            key = _param2[0],
            value = _param2[1];

        return Array.isArray(value) ? value.includes(_objectSpread(_objectSpread({}, defaultVariants), propsWithoutUndefined)[key]) : _objectSpread(_objectSpread({}, defaultVariants), propsWithoutUndefined)[key] === value;
      }) ? [].concat(_toConsumableArray(acc), [cvClass, cvClassName]) : acc;
    }, []);
    return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
  };
};